import React, { useState } from 'react';
import { Building2, Mail, Phone, Globe, AlertTriangle, Clock, FileCheck, Send, UploadCloud, ChevronLeft, ChevronDown, ChevronUp, CheckCircle, XCircle, History, Droplet, Leaf, Grape } from 'lucide-react';
export function SupplierDetails() {
  const [expandedCertId, setExpandedCertId] = useState<number | null>(null);
  const supplier = {
    id: 1,
    name: 'Napa Valley Vineyards',
    type: 'Grape Grower',
    status: 'at-risk',
    address: '1234 Vineyard Lane, St. Helena, CA 94574',
    email: 'compliance@napavalleyvineyards.com',
    phone: '+1 (707) 555-1234',
    website: 'www.napavalleyvineyards.com',
    complianceScore: 85,
    lastUpdated: '2 days ago',
    certifications: [{
      id: 1,
      name: 'CSWA Certification',
      status: 'valid',
      type: 'critical',
      expiryDate: '2024-12-31',
      lastUpdated: '2023-12-15',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-12-15',
        type: 'submission',
        status: 'approved',
        document: 'CSWA_Certification_2024.pdf',
        notes: 'Annual certification renewal approved',
        reviewer: 'Sarah Johnson'
      }, {
        id: 2,
        date: '2023-12-10',
        type: 'submission',
        status: 'pending',
        document: 'CSWA_Certification_2024.pdf',
        notes: 'Submitted for annual renewal',
        reviewer: null
      }, {
        id: 3,
        date: '2023-01-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Renewal reminder sent',
        reviewer: null
      }]
    }, {
      id: 2,
      name: 'SIP Certification',
      status: 'expiring-soon',
      type: 'critical',
      expiryDate: '2024-02-15',
      lastUpdated: '2023-06-20',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-06-20',
        type: 'submission',
        status: 'approved',
        document: 'SIP_Certification_2024.pdf',
        notes: 'Sustainability in Practice certification approved',
        reviewer: 'John Doe'
      }, {
        id: 2,
        date: '2023-06-15',
        type: 'submission',
        status: 'pending',
        document: 'SIP_Certification_2024.pdf',
        notes: 'Submitted for renewal',
        reviewer: null
      }, {
        id: 3,
        date: '2023-05-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Renewal reminder sent',
        reviewer: null
      }]
    }, {
      id: 3,
      name: 'Pesticide Residue Testing',
      status: 'expired',
      type: 'critical',
      expiryDate: '2024-01-01',
      lastUpdated: '2023-01-01',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-01-01',
        type: 'submission',
        status: 'approved',
        document: 'Pesticide_Testing_Report_2023.pdf',
        notes: 'Annual testing passed EU import standards',
        reviewer: 'Jane Smith'
      }, {
        id: 2,
        date: '2022-12-20',
        type: 'submission',
        status: 'pending',
        document: 'Pesticide_Testing_Report_2023.pdf',
        notes: 'Submitted for annual compliance',
        reviewer: null
      }, {
        id: 3,
        date: '2022-12-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Testing reminder sent',
        reviewer: null
      }]
    }, {
      id: 4,
      name: 'Water Usage Reporting',
      status: 'pending-review',
      type: 'non-critical',
      expiryDate: null,
      lastUpdated: '2024-01-10',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2024-01-10',
        type: 'submission',
        status: 'pending',
        document: 'Water_Usage_Report_2023.pdf',
        notes: 'Submitted quarterly water usage report',
        reviewer: null
      }, {
        id: 2,
        date: '2023-10-05',
        type: 'submission',
        status: 'approved',
        document: 'Water_Usage_Report_Q3_2023.pdf',
        notes: 'Q3 water usage report approved',
        reviewer: 'Emily Johnson'
      }, {
        id: 3,
        date: '2023-07-15',
        type: 'submission',
        status: 'approved',
        document: 'Water_Usage_Report_Q2_2023.pdf',
        notes: 'Q2 water usage report approved',
        reviewer: 'Emily Johnson'
      }]
    }, {
      id: 5,
      name: 'Harvest Documentation',
      status: 'valid',
      type: 'critical',
      expiryDate: null,
      lastUpdated: '2023-10-15',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-10-15',
        type: 'submission',
        status: 'approved',
        document: 'Harvest_Documentation_2023.pdf',
        notes: 'Complete chain of custody documentation for 2023 harvest',
        reviewer: 'Michael Torres'
      }, {
        id: 2,
        date: '2023-10-10',
        type: 'submission',
        status: 'pending',
        document: 'Harvest_Documentation_2023.pdf',
        notes: 'Submitted harvest documentation for review',
        reviewer: null
      }, {
        id: 3,
        date: '2023-09-01',
        type: 'notification',
        status: 'notification',
        document: null,
        notes: 'Harvest documentation requirements updated',
        reviewer: null
      }]
    }],
    communications: [{
      id: 1,
      type: 'email',
      subject: 'SIP Certification Expiring Soon',
      status: 'sent',
      date: '2024-01-15',
      description: 'Reminder sent about certification expiring in 30 days'
    }, {
      id: 2,
      type: 'document',
      subject: 'Pesticide Testing Report Upload',
      status: 'received',
      date: '2024-01-10',
      description: 'New pesticide testing report uploaded for review'
    }, {
      id: 3,
      type: 'email',
      subject: 'Pesticide Testing Expired',
      status: 'sent',
      date: '2024-01-02',
      description: 'Notification about expired testing requirement'
    }],
    grapeContracts: [{
      id: 1,
      variety: 'Cabernet Sauvignon',
      acres: 35,
      contractStart: '2022-01-01',
      contractEnd: '2025-12-31',
      status: 'active',
      lastHarvest: {
        date: '2023-09-15',
        tonnage: 87.5,
        quality: 'A+',
        brix: 24.8
      }
    }, {
      id: 2,
      variety: 'Chardonnay',
      acres: 22,
      contractStart: '2021-01-01',
      contractEnd: '2024-12-31',
      status: 'active',
      lastHarvest: {
        date: '2023-08-20',
        tonnage: 55.0,
        quality: 'A',
        brix: 23.5
      }
    }]
  };
  const toggleCertification = (certId: number) => {
    setExpandedCertId(expandedCertId === certId ? null : certId);
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'approved':
        return <CheckCircle className="w-4 h-4 text-green-600" data-id="element-12" />;
      case 'rejected':
        return <XCircle className="w-4 h-4 text-red-600" data-id="element-13" />;
      case 'pending':
        return <Clock className="w-4 h-4 text-yellow-600" data-id="element-14" />;
      default:
        return <History className="w-4 h-4 text-gray-600" data-id="element-15" />;
    }
  };
  const getCertificationIcon = (name: string) => {
    if (name.includes('Water')) return <Droplet className="w-4 h-4 mr-1" data-id="element-16" />;
    if (name.includes('SIP') || name.includes('CSWA')) return <Leaf className="w-4 h-4 mr-1" data-id="element-17" />;
    if (name.includes('Pesticide') || name.includes('Testing')) return <div className="w-4 h-4 mr-1" data-id="element-18" />;
    if (name.includes('Harvest')) return <Grape className="w-4 h-4 mr-1" data-id="element-19" />;
    return <FileCheck className="w-4 h-4 mr-1" data-id="element-20" />;
  };
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-21">
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-22">
        {/* Back Button */}
        <button className="flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-23">
          <ChevronLeft className="w-4 h-4 mr-1" data-id="element-24" />
          Back to Growers
        </button>
        {/* Supplier Header */}
        <div className="bg-white rounded-lg border p-6 mb-6" data-id="element-25">
          <div className="flex justify-between items-start" data-id="element-26">
            <div data-id="element-27">
              <h1 className="text-2xl font-semibold text-gray-900" data-id="element-28">
                {supplier.name}
              </h1>
              <p className="text-gray-600" data-id="element-29">{supplier.type}</p>
            </div>
            <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700" data-id="element-30">
              Edit Grower
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-31">
            <div className="space-y-3" data-id="element-32">
              <div className="flex items-center text-gray-600" data-id="element-33">
                <Building2 className="w-4 h-4 mr-2" data-id="element-34" />
                {supplier.address}
              </div>
              <div className="flex items-center text-gray-600" data-id="element-35">
                <Mail className="w-4 h-4 mr-2" data-id="element-36" />
                {supplier.email}
              </div>
              <div className="flex items-center text-gray-600" data-id="element-37">
                <Phone className="w-4 h-4 mr-2" data-id="element-38" />
                {supplier.phone}
              </div>
              <div className="flex items-center text-gray-600" data-id="element-39">
                <Globe className="w-4 h-4 mr-2" data-id="element-40" />
                {supplier.website}
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4" data-id="element-41">
              <div className="flex items-center justify-between mb-2" data-id="element-42">
                <span className="text-gray-600" data-id="element-43">Compliance Score</span>
                <span className="text-lg font-semibold text-gray-900" data-id="element-44">
                  {supplier.complianceScore}%
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-45">
                <div className="bg-green-500 rounded-full h-2" style={{
                width: `${supplier.complianceScore}%`
              }} data-id="element-46"></div>
              </div>
            </div>
          </div>
        </div>
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-47">
          {/* Certifications */}
          <div className="lg:col-span-2" data-id="element-48">
            <div className="bg-white rounded-lg border mb-6" data-id="element-49">
              <div className="p-6 border-b border-gray-200" data-id="element-50">
                <div className="flex items-center justify-between" data-id="element-51">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-52">
                    Certification Requirements
                  </h2>
                  <button className="text-purple-600 hover:text-purple-700 font-medium" data-id="element-53">
                    Add Requirement
                  </button>
                </div>
              </div>
              <div className="p-6" data-id="element-54">
                <div className="space-y-4" data-id="element-55">
                  {supplier.certifications.map(cert => <div key={cert.id} className="border rounded-lg p-4 hover:bg-gray-50" data-id="element-56">
                      <button className="w-full" onClick={() => toggleCertification(cert.id)} data-id="element-57">
                        <div className="flex items-start justify-between" data-id="element-58">
                          <div data-id="element-59">
                            <div className="flex items-center space-x-2" data-id="element-60">
                              <h3 className="font-medium text-gray-900" data-id="element-61">
                                {cert.name}
                              </h3>
                              <span className={`px-2 py-1 text-xs font-medium rounded-full ${cert.type === 'critical' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-62">
                                {cert.type}
                              </span>
                            </div>
                            <div className="mt-1 text-sm text-gray-600" data-id="element-63">
                              {cert.status === 'valid' && <div className="flex items-center text-green-600" data-id="element-64">
                                  {getCertificationIcon(cert.name)}
                                  Valid until {cert.expiryDate || 'N/A'}
                                </div>}
                              {cert.status === 'expiring-soon' && <div className="flex items-center text-yellow-600" data-id="element-65">
                                  <Clock className="w-4 h-4 mr-1" data-id="element-66" />
                                  Expires on {cert.expiryDate}
                                </div>}
                              {cert.status === 'expired' && <div className="flex items-center text-red-600" data-id="element-67">
                                  <AlertTriangle className="w-4 h-4 mr-1" data-id="element-68" />
                                  Expired on {cert.expiryDate}
                                </div>}
                              {cert.status === 'pending-review' && <div className="flex items-center text-blue-600" data-id="element-69">
                                  <Clock className="w-4 h-4 mr-1" data-id="element-70" />
                                  Pending Review
                                </div>}
                            </div>
                          </div>
                          <div className="flex space-x-2 items-center" data-id="element-71">
                            {cert.documentUrl && <button className="text-gray-600 hover:text-gray-900" onClick={e => e.stopPropagation()} data-id="element-72">
                                <FileCheck className="w-5 h-5" data-id="element-73" />
                              </button>}
                            <button className="text-purple-600 hover:text-purple-700" onClick={e => e.stopPropagation()} data-id="element-74">
                              <UploadCloud className="w-5 h-5" data-id="element-75" />
                            </button>
                            {expandedCertId === cert.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-76" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-77" />}
                          </div>
                        </div>
                      </button>
                      {/* Certification History */}
                      {expandedCertId === cert.id && <div className="mt-4 pt-4 border-t" data-id="element-78">
                          <h4 className="text-sm font-medium text-gray-900 mb-3" data-id="element-79">
                            Certification History
                          </h4>
                          <div className="space-y-4" data-id="element-80">
                            {cert.history?.map(event => <div key={event.id} className="flex items-start space-x-3" data-id="element-81">
                                <div className="flex-shrink-0" data-id="element-82">
                                  {getStatusIcon(event.status)}
                                </div>
                                <div className="flex-grow" data-id="element-83">
                                  <div className="flex items-center justify-between" data-id="element-84">
                                    <p className="text-sm font-medium text-gray-900" data-id="element-85">
                                      {event.type === 'submission' ? 'Document Submission' : 'System Notification'}
                                    </p>
                                    <span className="text-xs text-gray-500" data-id="element-86">
                                      {event.date}
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-600" data-id="element-87">
                                    {event.notes}
                                  </p>
                                  {event.document && <div className="mt-2 flex items-center space-x-2" data-id="element-88">
                                      <FileCheck className="w-4 h-4 text-gray-400" data-id="element-89" />
                                      <span className="text-sm text-gray-600" data-id="element-90">
                                        {event.document}
                                      </span>
                                    </div>}
                                  {event.reviewer && <p className="text-xs text-gray-500 mt-1" data-id="element-91">
                                      Reviewed by {event.reviewer}
                                    </p>}
                                </div>
                              </div>)}
                          </div>
                        </div>}
                    </div>)}
                </div>
              </div>
            </div>
            {/* Grape Contracts */}
            <div className="bg-white rounded-lg border" data-id="element-92">
              <div className="p-6 border-b border-gray-200" data-id="element-93">
                <div className="flex items-center justify-between" data-id="element-94">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-95">
                    Grape Contracts
                  </h2>
                  <button className="text-purple-600 hover:text-purple-700 font-medium" data-id="element-96">
                    Add Contract
                  </button>
                </div>
              </div>
              <div className="p-6" data-id="element-97">
                <div className="space-y-4" data-id="element-98">
                  {supplier.grapeContracts.map(contract => <div key={contract.id} className="border rounded-lg p-4 hover:bg-gray-50" data-id="element-99">
                      <div className="flex items-start justify-between" data-id="element-100">
                        <div data-id="element-101">
                          <div className="flex items-center space-x-2" data-id="element-102">
                            <h3 className="font-medium text-gray-900" data-id="element-103">
                              {contract.variety}
                            </h3>
                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800" data-id="element-104">
                              {contract.status}
                            </span>
                          </div>
                          <div className="mt-2 grid grid-cols-2 gap-x-8 gap-y-2 text-sm" data-id="element-105">
                            <div data-id="element-106">
                              <span className="text-gray-500" data-id="element-107">Acres: </span>
                              <span className="text-gray-900" data-id="element-108">
                                {contract.acres}
                              </span>
                            </div>
                            <div data-id="element-109">
                              <span className="text-gray-500" data-id="element-110">Contract: </span>
                              <span className="text-gray-900" data-id="element-111">
                                {contract.contractStart.substring(0, 4)} -{' '}
                                {contract.contractEnd.substring(0, 4)}
                              </span>
                            </div>
                            <div data-id="element-112">
                              <span className="text-gray-500" data-id="element-113">
                                Last Harvest:{' '}
                              </span>
                              <span className="text-gray-900" data-id="element-114">
                                {contract.lastHarvest.date}
                              </span>
                            </div>
                            <div data-id="element-115">
                              <span className="text-gray-500" data-id="element-116">Tonnage: </span>
                              <span className="text-gray-900" data-id="element-117">
                                {contract.lastHarvest.tonnage} tons
                              </span>
                            </div>
                            <div data-id="element-118">
                              <span className="text-gray-500" data-id="element-119">Quality: </span>
                              <span className="text-gray-900" data-id="element-120">
                                {contract.lastHarvest.quality}
                              </span>
                            </div>
                            <div data-id="element-121">
                              <span className="text-gray-500" data-id="element-122">Brix: </span>
                              <span className="text-gray-900" data-id="element-123">
                                {contract.lastHarvest.brix}°
                              </span>
                            </div>
                          </div>
                        </div>
                        <button className="text-purple-600 hover:text-purple-700" data-id="element-124">
                          <FileCheck className="w-5 h-5" data-id="element-125" />
                        </button>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
          {/* Sidebar */}
          <div className="space-y-6" data-id="element-126">
            {/* Communication History */}
            <div className="bg-white rounded-lg border" data-id="element-127">
              <div className="p-6 border-b border-gray-200" data-id="element-128">
                <div className="flex items-center justify-between" data-id="element-129">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-130">
                    Recent Communications
                  </h2>
                  <button className="text-purple-600 hover:text-purple-700" data-id="element-131">
                    <Send className="w-5 h-5" data-id="element-132" />
                  </button>
                </div>
              </div>
              <div className="p-6" data-id="element-133">
                <div className="space-y-4" data-id="element-134">
                  {supplier.communications.map(comm => <div key={comm.id} className="flex items-start space-x-3" data-id="element-135">
                      <div className={`p-2 rounded-full ${comm.type === 'email' ? 'bg-blue-100' : 'bg-green-100'}`} data-id="element-136">
                        {comm.type === 'email' ? <Mail className={`w-4 h-4 ${comm.type === 'email' ? 'text-blue-600' : 'text-green-600'}`} data-id="element-137" /> : <FileCheck className={`w-4 h-4 ${comm.type === 'email' ? 'text-blue-600' : 'text-green-600'}`} data-id="element-138" />}
                      </div>
                      <div data-id="element-139">
                        <p className="text-sm font-medium text-gray-900" data-id="element-140">
                          {comm.subject}
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-141">
                          {comm.description}
                        </p>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-142">
                          {comm.date}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
            {/* Quick Actions */}
            <div className="bg-white rounded-lg border p-6" data-id="element-143">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-144">
                Quick Actions
              </h3>
              <div className="space-y-3" data-id="element-145">
                <button className="w-full bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700" data-id="element-146">
                  Request Certificate Update
                </button>
                <button className="w-full border border-gray-200 text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-50" data-id="element-147">
                  Download Harvest Reports
                </button>
                <button className="w-full border border-gray-200 text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-50" data-id="element-148">
                  View Testing History
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}